import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../store"
import { useLocation } from "react-router-dom";
import { useNavigation } from "./useNavigation";
import { useCallback, useMemo } from "react";
import { SIDEBAR_MENUS } from "../constants/sidebar";
import { authActions, authSelectors } from "../ducks/auth";
import { appActions } from "../ducks/app";
import { LocalStorageManager } from "../core/storage/LocalStorageManager";
import { AppConfig } from "../AppConfig";
import { PageRoute } from "../constants/routes";
import { handleAuthLogout } from "../utils/auth";

export const useSidebar = () => {
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    const { navigateToPage } = useNavigation();
    const loggedInUser = useSelector(authSelectors.loggedInUser);

    const username = useMemo(() => {
        return loggedInUser?.username || ""
    }, [loggedInUser])

    const sidebarMenusToShow = useMemo(() => {
        // Show all menu items for all users - let individual pages handle permissions
        return SIDEBAR_MENUS;
    }, [])

    const selectedMenuPath = useMemo(() => {
        return location.pathname;
    }, [location.pathname, sidebarMenusToShow]);

    const onSidebarMenuClick = useCallback((path: string) => {
        navigateToPage(path);
    }, []);

    const handleLogout = useCallback(() => {
        // Get refresh token for logout request
        const refresh = LocalStorageManager.Instance.getObject(AppConfig.Instance.LocalStorageKey["refreshToken"]) as string || "";

        // Dispatch logout action
        dispatch(authActions.logout.started({
            refresh,
            onSuccess: () => {
                // Clean up local state and redirect to login after successful logout
                handleAuthLogout();
            },
            onError: () => {
                // Even on error, clean up local state and redirect to login
                handleAuthLogout();
            }
        }));
    }, [dispatch, navigateToPage]);

    return {
        username,
        sidebarMenusToShow,
        selectedMenuPath,
        onSidebarMenuClick,
        handleLogout
    }
}